import React, { Fragment } from 'react';
import Script from 'dangerous-html/react';
import PropTypes from 'prop-types';
import './hero.css';
import { useTranslation } from 'react-i18next';

const Hero = (props) => {
  const { t } = useTranslation();
  return (
    <div className={`hero-header78 ${props.rootClassName} `}>
      <div className='hero-column thq-section-max-width thq-section-padding'>
        <div className='hero-content'>
          <h1 className='hero-text10 thq-heading-1'>
            {props.heading1 ?? (
              <Fragment>
                <span className='hero-text19'>{t('hero.heading')}</span>
              </Fragment>
            )}
          </h1>
          <h2 className='hero-text11'>{t('hero.subheading')}</h2>
          <p className='hero-text16 thq-body-large'>
            {props.content1 ?? (
              <Fragment>
                <span className='hero-text24'>{t('hero.description')}</span>
              </Fragment>
            )}
          </p>
        </div>
        <div className='hero-actions'>
          <a
            href='https://t.me/schengen_visa_slot_bot?start=we_01_0000'
            target='_blank'
            rel='noreferrer noopener'
            className='hero-button thq-button-filled'
          >
            <span className='thq-body-small'>
              {props.action1 ?? (
                <Fragment>
                  <span className='hero-text18'>{t('hero.subscribe')}</span>
                </Fragment>
              )}
            </span>
          </a>
        </div>
      </div>
      <div>
        <div className='hero-container2'>
          <Script
            html={`<style>
  @keyframes scroll-x {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - 16px));
    }
  }

  @keyframes scroll-y {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(calc(-100% - 16px));
    }
  }
</style>
`}
          ></Script>
        </div>
      </div>
    </div>
  );
};

Hero.defaultProps = {
  action1: undefined,
  heading1: undefined,
  rootClassName: '',
  content1: undefined,
};

Hero.propTypes = {
  action1: PropTypes.element,
  heading1: PropTypes.element,
  rootClassName: PropTypes.string,
  content1: PropTypes.element,
};

export default Hero;
